import PlaylistItem from './PlaylistItem';

export default PlaylistItem;
